import classnames from 'classnames';
import { withPropsOnChange } from 'recompose';

export const withClassNames = (...classNames) =>
  withPropsOnChange(['className'], ({ className }) => ({
    className: classnames(...classNames, { [className]: className })
  }));
